/**
 * PasswordInput — show/hide toggle for auth forms (Eye / EyeOff from lucide).
 */
import { useState, InputHTMLAttributes } from 'react'
import { Eye, EyeOff } from 'lucide-react'

type PasswordInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  inputClassName?: string
}

export default function PasswordInput({
  inputClassName = 'fld-i',
  style,
  id,
  ...rest
}: PasswordInputProps) {
  const [visible, setVisible] = useState(false)

  return (
    <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
      <input
        {...rest}
        id={id}
        type={visible ? 'text' : 'password'}
        className={inputClassName}
        style={{ width: '100%', paddingRight: 40, ...style }}
      />
      <button
        type="button"
        tabIndex={0}
        aria-label={visible ? 'Hide password' : 'Show password'}
        onClick={() => setVisible(v => !v)}
        style={{
          position: 'absolute',
          right: 8,
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: 'var(--ink4)',
          display: 'flex',
          alignItems: 'center',
          padding: 4,
          minWidth: 32,
          minHeight: 32,
          justifyContent: 'center',
        }}
      >
        {visible ? <EyeOff size={16} aria-hidden /> : <Eye size={16} aria-hidden />}
      </button>
    </div>
  )
}
